import React from "react"
import type { SubjectPerformance } from "../../types"

/** Aproveitamento por matéria (barras horizontais). Destaca a matéria mais fraca. */
export function SubjectBars({ subjects }: { subjects: SubjectPerformance[] }) {
  const answered = subjects.filter((s) => s.total > 0)
  const weakest = answered.length > 1 ? answered.reduce((a, b) => (b.accuracy < a.accuracy ? b : a)) : null
  const ordered = [...subjects].sort((a, b) => b.accuracy - a.accuracy)

  return (
    <div className="flex flex-col gap-3">
      {ordered.map((s) => {
        const focus = weakest?.subject === s.subject
        return (
          <div key={s.subject}>
            <div className="mb-1 flex items-center justify-between gap-2 text-xs">
              <span className="flex items-center gap-1.5 text-navy-800">
                {s.subject}
                {focus && (
                  <span className="rounded-full bg-red-100 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-red-600">
                    focar
                  </span>
                )}
              </span>
              <span className="shrink-0 tabular-nums text-navy-500">
                {s.correct}/{s.total} · <span className="font-semibold text-navy-900">{s.accuracy}%</span>
              </span>
            </div>
            <div
              className="relative h-2.5"
              role="progressbar"
              aria-valuenow={s.accuracy}
              aria-valuemin={0}
              aria-valuemax={100}
              aria-label={`${s.subject}: ${s.accuracy}% de acertos`}
            >
              {/* trilha fina de fundo */}
              <div className="absolute inset-x-0 top-1/2 h-1 -translate-y-1/2 rounded-full bg-slate-100" />
              {/* barra preenchida — mais grossa, verde */}
              <div
                className="absolute left-0 top-1/2 h-2.5 -translate-y-1/2 rounded-full bg-emerald-500"
                style={{ width: `${s.accuracy}%` }}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}
